import { NXDataSourcePrime } from '../../../core/services/dataSource/NXDataSourcePrime';
import { Apollo } from 'apollo-angular';
import { environment } from 'src/environments/environment';
import { LocationEntity } from '../../../shared-module/shared/entities/location/location';
import * as fromGraphQl from './graphql';

export class LocationDataSource extends NXDataSourcePrime<LocationEntity> {
  constructor(apollo: Apollo) {
    super(apollo, fromGraphQl.LOCATIONS_QUERY, environment);
  }
  handleSubscriptionResult(data: fromGraphQl.LocationsQueryResponse): void {
    super.setSubject(
      data.locations?.content ? data.locations?.content : [],
      data.locations?.totalElements ? data.locations.totalElements : 0
    );
  }

  loadLocations(variables: any): void {
    this.querySubscription?.unsubscribe();
    this.subscribeToQuery(variables);
  }
}
